import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

import { IonicModule } from '@ionic/angular';

import {CustomModule} from "../customs/custom.module";

import {NotificationDetailRoutingModule} from "./notification-detail-routing.module";
import {NotificationDetailComponent} from "./notification-detail.component";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    TranslateModule,    
    NotificationDetailRoutingModule,
      CustomModule
  ],
  declarations: [NotificationDetailComponent]
})
export class NotificationDetailModule {}
